import { render, staticRenderFns } from "./plataccount-refund.vue?vue&type=template&id=707d2041&scoped=true&"
import script from "./plataccount-refund.vue?vue&type=script&lang=js&"
export * from "./plataccount-refund.vue?vue&type=script&lang=js&"
import style0 from "./plataccount-refund.vue?vue&type=style&index=0&id=707d2041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d2041",
  null
  
)

export default component.exports